module.exports = __webpack_public_path__ + "media/aerial.e173e2b9.mp4";